// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]7.2-rc-12430(af1acdd5b6)-C17/06/2026-11:39:05-B17/06/2026-11:44:45' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]7.2-rc-12430(af1acdd5b6)-C17/06/2026-11:39:05-B17/06/2026-11:44:45",
  branch: "test",
  latestTag: "7.2-rc",
  revCount: "12430",
  shortHash: "af1acdd5b6",
  longHash: "af1acdd5b6e8111340c7e87392149ae23645404c",
  dateCommit: "17/06/2026-11:39:05",
  dateBuild: "17/06/2026-11:44:45",
  buildType: "Ansible",
  } ;
